import { Component } from '@opten/compiler/metadata/component';
import { MapStyles } from '../shared/map';
import { MapSearcher } from '../shared/map-searcher';

@Component({ className: 'js-map-filter' })
export class MapFilterComponent {
	private mapSearcher: MapSearcher;

	constructor(private element: HTMLElement) {
		this.mapSearcher = new MapSearcher(element, window, {
			mapStyles: MapStyles,
			radiusBounds: parseInt(this.element.getAttribute("data-radius") || '0')
		});
		
		this.mapSearcher.filter.filters.forEach((filter) => {
			filter.addEventListener('change', () => {
				this.mapSearcher.search();
			});
		});
	}
}
